import { OrganizationType } from "@platform/types/orgInvitation.types";
import { createEventBus } from "@shared/features/eventBus/createEventBus";

export type OrgInvitationEvents = {
  "code:submitted": { code: string };
  "code:success": { code: string; response: object };
  "code:failed": { code: string };
  "lookupOrg:notFound": { name: string };
  "lookupOrg:submitted": { organization: OrganizationType };
  "lookupOrg:success": { organization: OrganizationType; response: object };
  "lookupOrg:failed": { organization: OrganizationType };
  "lookupOrg:inviteIntent": { organization: OrganizationType };
  "lookupOrg:joinIntent": { organization: OrganizationType };
};

export default OrgInvitationEvents;

export const orgInvitationEventBus = createEventBus<OrgInvitationEvents>();
